<template>
  <div class="carousel-wrapper">
    <!-- 卡片式轮播容器 -->
    <div class="carousel-container" :style="isMobile ? 'height: 40vh' : 'height: 60vh'">
      <el-carousel ref="myCarousel" :autoplay="false" :height="isMobile ? '40vh' : '60vh'" :interval="6000"
        :arrow="'always'" indicator-position="none" trigger="click" :type="isMobile ? '' : 'card'"
        @change="handleCarouselChange">
        <el-carousel-item v-for="(item, idx) in carouselItems" :key="idx">
          <div class="card-content" :class="{ 'mobile-mode': isMobile }">
            <div class="media-wrapper" :class="{ 'contain-mode': true }">
              <video v-if="item.videoUrl && idx === activeIndex" :ref="setVideoRef" :src="getCurrentVideoUrl(item)"
                :muted="true" :playsinline="true" :autoplay="true" preload="auto" @ended="handleVideoEnded"
                @play="handleVideoPlay" @pause="handleVideoPause" @error="handleVideoError"></video>
              <img v-else-if="item.videoUrl && idx !== activeIndex" :src="getCurrentVideoPoster(item)"
                :alt="item.title || '视频封面'" loading="lazy">
              <img v-else-if="item.imageUrl" :src="getCurrentImageUrl(item)" :alt="item.title || '轮播图片'" loading="lazy">
            </div>

            <!-- 可收缩的卡片文案层 - 只有当前激活的卡片才能交互 -->
            <div class="card-caption" v-if="idx === activeIndex" :class="{
              'collapsed': isCaptionCollapsed && !isMobile && idx === activeIndex,
              'expanded': !isCaptionCollapsed && !isMobile && idx === activeIndex,
              'inactive-caption': idx !== activeIndex,
              'mobile-collapsed': isMobile && !isMobileExpanded[idx] && idx === activeIndex,
              'mobile-expanded': isMobile && isMobileExpanded[idx] && idx === activeIndex,
              'mobile-inactive': isMobile && idx !== activeIndex
            }" @mouseenter="idx === activeIndex && handleCaptionMouseEnter()"
              @mouseleave="idx === activeIndex && handleCaptionMouseLeave()"
              @click="idx === activeIndex && handleCaptionClick()">
              <!-- 收缩状态下的圆形按钮 -->
              <div class="expand-btn" v-if="isCaptionCollapsed && !isMobile && idx === activeIndex">
                <i class="el-icon-info"></i>
              </div>

              <!-- 展开状态下的完整内容 -->
              <div class="caption-content"
                v-if="(!isCaptionCollapsed && idx === activeIndex) || (isMobile && isMobileExpanded[idx])">
                <h2>{{ item.title }}</h2>
                <p>{{ item.description }}</p>
                <button type="button" class="btn btn-outline-light" v-if="item.toType || item.funName"
                  @click.stop="routerFun(item)">
                  查看更多
                </button>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- Tab 图标导航栏 -->
    <div class="tab-nav" :class="{ 'mobile-tab': isMobile }">
      <div v-for="(item, index) in carouselItems" :key="index" class="tab-item"
        :class="{ active: activeIndex === index }" @click="handleTabClick(index)">
        <div class="tab-icon">
          <i :class="item.iconClass"></i>
        </div>
        <span class="tab-label" v-if="!isMobile">{{ item.tabLabel || `Tab ${index + 1}` }}</span>
        <span class="tab-label-mobile" v-else>{{ item.shortLabel || '' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardCarouselComponent",
  data() {
    return {
      activeIndex: 0,
      isVideoPlaying: false,
      isMobile: window.innerWidth <= 768,
      currentVideoRef: null,
      autoPlayTimer: null,
      isComponentDestroyed: false,
      isCaptionCollapsed: false,
      collapseTimer: null,
      isMobileExpanded: {},
      isAnimating: false,
      hoverTimer: null,
      carouselItems: [
        {
          videoUrl: "https://www.hqhotel5.com/media/artspace_1.mp4",
          mobileVideoUrl: "https://www.hqhotel5.com/media/artspace.mp4",
          videoPoster: "https://www.hqhotel5.com/media/posters/artspace.png",
          mobileVideoPoster: "https://www.hqhotel5.com/media/posters/artspace.png",
          title: '艺术空间',
          toType: '/artspace',
          description: "沉浸式艺术体验，感受艺术与空间的完美融合",
          iconClass: "el-icon-picture",
          tabLabel: "艺术空间",
          shortLabel: "艺术"
        },
        {
          videoUrl: "https://www.hqhotel5.com/media/location_1.mp4",
          mobileVideoUrl: "https://www.hqhotel5.com/media/location.mp4",
          videoPoster: "https://www.hqhotel5.com/media/posters/location.png",
          mobileVideoPoster: "https://www.hqhotel5.com/media/posters/location.png",
          title: '地理位置',
          toType: '',
          funName: 'openMap',
          description: "城市中心枢纽，交通便利，四通八达",
          iconClass: "el-icon-location",
          tabLabel: "地理位置",
          shortLabel: "位置"
        },
        {
          videoUrl: "https://www.hqhotel5.com/media/pe_1.mp4",
          mobileVideoUrl: "https://www.hqhotel5.com/media/pe.mp4",
          videoPoster: "https://www.hqhotel5.com/media/posters/pe.png",
          mobileVideoPoster: "https://www.hqhotel5.com/media/posters/pe.png",
          title: '专业团队',
          toType: '',
          description: "卓越服务体验，专业团队为您保驾护航",
          iconClass: "el-icon-user",
          tabLabel: "专业团队",
          shortLabel: "团队"
        },
        {
          videoUrl: "https://www.hqhotel5.com/media/pillow_1.mp4",
          mobileVideoUrl: "https://www.hqhotel5.com/media/pillow.mp4",
          videoPoster: "https://www.hqhotel5.com/media/posters/pillow.png",
          mobileVideoPoster: "https://www.hqhotel5.com/media/posters/pillow.png",
          title: '舒适睡眠',
          toType: '',
          description: "云端睡眠享受，精选床品助您好梦",
          iconClass: "el-icon-star-off",
          tabLabel: "舒适睡眠",
          shortLabel: "睡眠"
        },
        {
          imageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/1_1.jpg",
          mobileImageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/1_1.jpg",
          title: "门厅",
          toType: "",
          description: "优雅社交空间，品味精致生活",
          iconClass: "el-icon-coffee",
          tabLabel: "门厅",
          shortLabel: "门厅"
        },
        {
          imageUrl: "https://www.hqhotel5.com/img/hotelImgs/eat_game/eat01.png",
          mobileImageUrl: "https://www.hqhotel5.com/img/hotelImgs/eat_game/eat01.png",
          title: "餐厅",
          toType: "",
          description: "环球美食体验，舌尖上的享受",
          iconClass: "el-icon-food",
          tabLabel: "餐厅",
          shortLabel: "餐厅"
        },
        {
          imageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/1_3.png",
          mobileImageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/1_3.png",
          title: "大堂",
          toType: "",
          description: "高级专业大堂，快速高效舒适",
          iconClass: "el-icon-office-building",
          tabLabel: "大堂",
          shortLabel: "大堂"
        },
        {
          imageUrl: "https://www.hqhotel5.com/img/hotelImgs/eat_game/game08.jpg",
          mobileImageUrl: "https://www.hqhotel5.com/img/hotelImgs/eat_game/game08.jpg",
          title: "健身房",
          toType: "",
          description: "活力健身空间，保持健康体魄",
          iconClass: "el-icon-bicycle",
          tabLabel: "健身房",
          shortLabel: "健身"
        },
        {
          imageUrl: "https://www.hqhotel5.com/img/hotelImgs/bigbed/yz/1.png",
          mobileImageUrl: "https://www.hqhotel5.com/img/hotelImgs/bigbed/yz/1.png",
          title: "客房",
          toType: "",
          description: "智慧客房，全新体验",
          iconClass: "el-icon-house",
          tabLabel: "客房",
          shortLabel: "客房"
        },
        {
          imageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/1_6.png",
          mobileImageUrl: "https://www.hqhotel5.com/img/hotelImgs/20260202lobby/1_6.png",
          title: "门厅",
          toType: "",
          description: "身心放松之旅，焕发新生",
          iconClass: "el-icon-picture",
          tabLabel: "门厅",
          shortLabel: "门厅"
        },
      ]
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.startAutoPlay();

    if (!this.isMobile) {
      this.startCollapseTimer();
    }

    if (this.isMobile) {
      this.carouselItems.forEach((_, idx) => {
        this.$set(this.isMobileExpanded, idx, false);
      });
    }
  },
  beforeDestroy() {
    this.isComponentDestroyed = true;
    window.removeEventListener("resize", this.handleResize);
    this.stopAutoPlay();
    this.pauseCurrentVideo();
    this.clearCollapseTimer();
    this.clearHoverTimer();
  },
  methods: {

    // 打开地图功能
    openMap() {
      // 酒店坐标（横琴粤澳深度合作区七色彩虹路1011号附近经纬度）
      const latitude = 22.12566379676462;
      const longitude = 113.52018936042093;
      const address = encodeURIComponent('横琴粤澳深度合作区七色彩虹路1011号（天汇星影视综合城）');

      // 检测设备平台，使用对应的地图应用
      const ua = navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(ua);
      const isAndroid = /android/.test(ua);

      if (isIOS) {
        // iOS 使用苹果地图
        window.location.href = `http://maps.apple.com/?ll=${latitude},${longitude}&q=${address}`;
      } else if (isAndroid) {
        // Android 尝试使用高德地图或谷歌地图
        window.location.href = `https://uri.amap.com/marker?position=${longitude},${latitude}&name=${address}`;
      } else {
        // 桌面端打开高德地图网页版
        window.open(`https://www.amap.com/search?query=${address}&city=珠海`, '_blank');
      }
    },

    setVideoRef(el) {
      if (el && !this.isComponentDestroyed) {
        this.currentVideoRef = el;
      }
    },

    getCurrentVideoUrl(item) {
      if (!item) return '';
      if (this.isMobile && item.mobileVideoUrl) {
        return item.mobileVideoUrl;
      }
      return item.videoUrl;
    },

    getCurrentVideoPoster(item) {
      if (!item) return '';
      if (this.isMobile && item.mobileVideoPoster) {
        return item.mobileVideoPoster;
      }
      return item.videoPoster || '';
    },

    getCurrentImageUrl(item) {
      if (!item) return '';
      if (this.isMobile && item.mobileImageUrl) {
        return item.mobileImageUrl;
      }
      return item.imageUrl;
    },

    reloadCurrentMedia() {
      if (this.isComponentDestroyed) return;

      const currentItem = this.carouselItems[this.activeIndex];
      if (!currentItem) return;

      if (currentItem.videoUrl && this.currentVideoRef) {
        const wasPlaying = !this.currentVideoRef.paused;
        const currentTime = this.currentVideoRef.currentTime;
        const newSrc = this.getCurrentVideoUrl(currentItem);

        if (this.currentVideoRef.src !== newSrc) {
          this.currentVideoRef.src = newSrc;
          this.currentVideoRef.load();
          if (wasPlaying) {
            this.currentVideoRef.play().catch(err => {
              console.warn("视频恢复播放失败:", err);
            });
            this.currentVideoRef.currentTime = currentTime;
          }
        }
      }
    },

    handleResize() {
      if (this.isComponentDestroyed) return;

      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;

      if (wasMobile !== this.isMobile) {
        this.reloadCurrentMedia();

        if (this.isMobile) {
          this.isCaptionCollapsed = false;
          this.clearCollapseTimer();
          this.carouselItems.forEach((_, idx) => {
            if (this.isMobileExpanded[idx] === undefined) {
              this.$set(this.isMobileExpanded, idx, false);
            }
          });
        } else {
          this.isCaptionCollapsed = false;
          this.carouselItems.forEach((_, idx) => {
            this.$set(this.isMobileExpanded, idx, false);
          });
          this.startCollapseTimer();
        }
      }
    },

    startCollapseTimer() {
      this.clearCollapseTimer();
      this.collapseTimer = setTimeout(() => {
        if (!this.isComponentDestroyed && !this.isMobile && !this.isAnimating && !this.isCaptionCollapsed) {
          this.isCaptionCollapsed = true;
        }
      }, 2000);
    },

    clearCollapseTimer() {
      if (this.collapseTimer) {
        clearTimeout(this.collapseTimer);
        this.collapseTimer = null;
      }
    },

    clearHoverTimer() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
    },

    handleCaptionMouseEnter() {
      if (this.isMobile) return;

      this.clearHoverTimer();
      this.clearCollapseTimer();

      if (this.isCaptionCollapsed && !this.isAnimating) {
        this.isAnimating = true;
        this.isCaptionCollapsed = false;
        setTimeout(() => {
          this.isAnimating = false;
        }, 400);
      }
    },

    handleCaptionMouseLeave() {
      if (this.isMobile) return;

      this.clearHoverTimer();

      if (!this.isCaptionCollapsed && !this.isAnimating) {
        this.hoverTimer = setTimeout(() => {
          if (!this.isAnimating && !this.isCaptionCollapsed) {
            this.isAnimating = true;
            this.isCaptionCollapsed = true;
            setTimeout(() => {
              this.isAnimating = false;
              this.startCollapseTimer();
            }, 400);
          }
          this.hoverTimer = null;
        }, 100);
      }
    },

    handleCaptionClick() {
      if (!this.isMobile) return;

      const currentIdx = this.activeIndex;
      this.$set(this.isMobileExpanded, currentIdx, !this.isMobileExpanded[currentIdx]);

      this.carouselItems.forEach((_, idx) => {
        if (idx !== currentIdx && this.isMobileExpanded[idx]) {
          this.$set(this.isMobileExpanded, idx, false);
        }
      });
    },

    startAutoPlay() {
      if (this.isComponentDestroyed) return;

      this.stopAutoPlay();
      if (!this.isVideoPlaying) {
        this.autoPlayTimer = setInterval(() => {
          if (this.$refs.myCarousel && !this.isVideoPlaying && !this.isComponentDestroyed) {
            this.$refs.myCarousel.next();
          }
        }, 5000);
      }
    },

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },

    handleTabClick(index) {
      if (index === this.activeIndex) return;

      if (this.currentVideoRef) {
        this.currentVideoRef.pause();
      }

      if (this.$refs.myCarousel) {
        this.$refs.myCarousel.setActiveItem(index);
      }

      this.activeIndex = index;

      if (!this.isMobile) {
        this.isCaptionCollapsed = false;
        this.clearCollapseTimer();
        this.startCollapseTimer();
      } else {
        this.carouselItems.forEach((_, idx) => {
          if (this.isMobileExpanded[idx]) {
            this.$set(this.isMobileExpanded, idx, false);
          }
        });
      }

      const currentItem = this.carouselItems[index];
      if (currentItem && currentItem.videoUrl) {
        this.stopAutoPlay();
        this.isVideoPlaying = false;
      } else {
        this.isVideoPlaying = false;
        this.startAutoPlay();
      }
    },

    handleCarouselChange(newIndex) {
      if (this.isComponentDestroyed) return;

      const prevIndex = this.activeIndex;
      this.activeIndex = newIndex;

      if (this.currentVideoRef && prevIndex !== newIndex) {
        this.currentVideoRef.pause();
      }

      if (!this.isMobile) {
        this.isCaptionCollapsed = false;
        this.clearCollapseTimer();
        this.startCollapseTimer();
      } else {
        this.carouselItems.forEach((_, idx) => {
          if (this.isMobileExpanded[idx]) {
            this.$set(this.isMobileExpanded, idx, false);
          }
        });
      }

      const currentItem = this.carouselItems[newIndex];
      if (currentItem && currentItem.videoUrl) {
        this.stopAutoPlay();
        this.isVideoPlaying = false;
      } else {
        this.isVideoPlaying = false;
        this.startAutoPlay();
      }
    },

    handleVideoPlay() {
      if (this.isComponentDestroyed) return;
      this.isVideoPlaying = true;
      this.stopAutoPlay();
    },

    handleVideoPause() {
      if (this.isComponentDestroyed) return;
      this.isVideoPlaying = false;
      if (this.carouselItems[this.activeIndex]?.videoUrl) {
        this.stopAutoPlay();
      } else {
        this.startAutoPlay();
      }
    },

    handleVideoError(e) {
      console.warn('视频播放错误:', e);
      this.isVideoPlaying = false;
      this.startAutoPlay();
    },

    handleVideoEnded() {
      if (this.isComponentDestroyed) return;

      this.isVideoPlaying = false;
      this.$nextTick(() => {
        if (this.$refs.myCarousel && !this.isComponentDestroyed) {
          this.$refs.myCarousel.next();
        }
        this.startAutoPlay();
      });
    },

    pauseCurrentVideo() {
      if (this.currentVideoRef) {
        this.currentVideoRef.pause();
      }
    },

    routerFun(item) {
      if (item.toType && this.$router) {
        this.$router.push(item.toType);
      }else if (item.funName) {
        this[item.funName]()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel-wrapper {
  position: relative;
  background: linear-gradient(to bottom, grey, transparent);
  width: 100%;
  padding-bottom: 20px;
}

.carousel-container {
  position: relative;
  overflow: visible;
  user-select: none;
  width: 100%;

  @media (min-width: 769px) {
    padding: 20px 0;
  }
}

.card-content {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
  background-color: #000;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);

  &.mobile-mode {
    border-radius: 0;
    box-shadow: none;
  }
}

.media-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #000;

  /* 使用 contain 确保完整显示，不裁剪 */
  &.contain-mode {

    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      /* 确保完整显示，不裁剪 */
      background-color: #000;
    }
  }

  /* 默认使用 cover 保持原有行为，但添加 contain 类后使用 contain */
  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/* 卡片内容文案层 - 从下到上滑入滑出动画 */
.card-caption {
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  color: white;
  z-index: 10;
  overflow: hidden;

  /* PC端展开状态 - 完整内容，从下到上滑入 */
  &.expanded {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
    backdrop-filter: blur(8px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 1rem 1.2rem;
    pointer-events: auto;
    cursor: pointer;
    animation: slideUpExpand 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;

    .caption-content {
      display: block;
      animation: contentFadeIn 0.3s ease 0.1s forwards;
    }

    .expand-btn {
      display: none;
    }

    &:hover {
      transform: translateY(-3px);
      background: linear-gradient(135deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.6) 100%);
    }
  }

  /* PC端收缩状态 - 圆形按钮 */
  &.collapsed {
    width: 44px;
    height: 44px;
    padding: 0;
    right: auto;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
    cursor: pointer;
    animation: slideDownCollapse 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;

    .expand-btn {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 20px;
        color: white;
      }
    }

    .caption-content {
      display: none;
    }

    &:hover {
      transform: scale(1.05);
      background: rgba(0, 0, 0, 0.85);
    }
  }

  /* 非激活的卡片 - 始终显示，无动画 */
  &.inactive-caption {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%);
    backdrop-filter: blur(8px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    padding: 1rem 1.2rem;
    pointer-events: none;
    cursor: default;
    opacity: 0.8;

    .caption-content {
      display: block;
    }

    &:hover {
      transform: none;
    }
  }

  /* 移动端激活卡片收缩状态 */
  &.mobile-collapsed {
    width: 40px;
    height: 40px;
    padding: 0;
    right: auto;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
    cursor: pointer;

    &::before {
      content: "i";
      font-size: 18px;
      font-weight: bold;
      color: white;
      font-family: serif;
      font-style: italic;
    }

    .caption-content {
      display: none;
    }
  }

  /* 移动端激活卡片展开状态 */
  &.mobile-expanded {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0.7) 100%);
    backdrop-filter: blur(8px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 0.8rem 1rem;
    pointer-events: auto;
    cursor: pointer;
    animation: slideUpExpandMobile 0.35s ease forwards;

    .caption-content {
      display: block;
    }
  }

  /* 移动端非激活卡片 */
  &.mobile-inactive {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%);
    backdrop-filter: blur(8px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    padding: 0.8rem 1rem;
    pointer-events: none;
    cursor: default;
    opacity: 0.8;

    .caption-content {
      display: block;
    }
  }

  .caption-content {
    h2 {
      font-size: 1.4rem;
      margin-bottom: 0.3rem;
      color: white;
      font-weight: 600;
      opacity: 0;
      animation: slideInUp 0.3s ease 0.1s forwards;
    }

    p {
      font-size: 0.85rem;
      margin-bottom: 0.8rem;
      color: rgba(255, 255, 255, 0.9);
      opacity: 0;
      animation: slideInUp 0.3s ease 0.15s forwards;
    }

    button {
      background-color: transparent;
      border: 1px solid white;
      color: white;
      padding: 0.4rem 1.2rem;
      border-radius: 25px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 0.8rem;
      opacity: 0;
      animation: slideInUp 0.3s ease 0.2s forwards;

      &:hover {
        background-color: white;
        color: black;
        transform: translateX(3px);
      }
    }
  }

  @media (max-width: 768px) {

    &.mobile-expanded,
    &.mobile-inactive {
      .caption-content {
        h2 {
          font-size: 1rem;
          margin-bottom: 0.2rem;
        }

        p {
          font-size: 0.7rem;
          margin-bottom: 0.5rem;
        }

        button {
          padding: 0.2rem 0.8rem;
          font-size: 0.65rem;
        }
      }
    }
  }
}

/* 展开动画 - 从圆形按钮位置向上滑出 */
@keyframes slideUpExpand {
  0% {
    width: 44px;
    height: 44px;
    padding: 0;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.75);
    left: 20px;
    right: auto;
    bottom: 20px;
  }

  40% {
    width: calc(100% - 40px);
    height: 44px;
    padding: 0;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.75);
    left: 20px;
    right: 20px;
    bottom: 20px;
  }

  100% {
    width: calc(100% - 40px);
    height: auto;
    padding: 1rem 1.2rem;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
    left: 20px;
    right: 20px;
    bottom: 20px;
  }
}

/* 收缩动画 - 向下收缩回圆形按钮 */
@keyframes slideDownCollapse {
  0% {
    width: calc(100% - 40px);
    height: auto;
    padding: 1rem 1.2rem;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
    left: 20px;
    right: 20px;
    bottom: 20px;
  }

  60% {
    width: calc(100% - 40px);
    height: 44px;
    padding: 0;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.75);
    left: 20px;
    right: 20px;
    bottom: 20px;
  }

  100% {
    width: 44px;
    height: 44px;
    padding: 0;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.75);
    left: 20px;
    right: auto;
    bottom: 20px;
  }
}

/* 移动端展开动画 */
@keyframes slideUpExpandMobile {
  0% {
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 50%;
    left: 15px;
    right: auto;
    bottom: 15px;
  }

  100% {
    width: calc(100% - 30px);
    height: auto;
    padding: 0.8rem 1rem;
    border-radius: 12px;
    left: 15px;
    right: 15px;
    bottom: 15px;
  }
}

/* 内容淡入上滑 */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 内容淡入 */
@keyframes contentFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Tab 图标导航栏 */
.tab-nav {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(12px);
  padding: 10px 20px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  width: fit-content;
  margin: 20px auto 0;
  z-index: 20;
  margin-top: 30px;

  .tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px 14px;
    border-radius: 35px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: rgba(255, 255, 255, 0.7);
    min-width: 65px;

    .tab-icon {
      font-size: 18px;
      margin-bottom: 3px;
      transition: transform 0.2s ease;
    }

    .tab-label {
      font-size: 10px;
      font-weight: 500;
      white-space: nowrap;
    }

    .tab-label-mobile {
      font-size: 9px;
      font-weight: 500;
    }

    &:hover {
      color: white;
      background: rgba(255, 255, 255, 0.15);

      .tab-icon {
        transform: scale(1.1);
      }
    }

    &.active {
      color: white;
      background: rgba(255, 255, 255, 0.25);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

      .tab-icon {
        transform: scale(1.05);
      }

      .tab-label,
      .tab-label-mobile {
        font-weight: 600;
      }
    }
  }

  &.mobile-tab {
    gap: 4px;
    padding: 6px 12px;
    margin-top: 15px;

    .tab-item {
      padding: 3px 8px;
      min-width: auto;

      .tab-icon {
        font-size: 14px;
        margin-bottom: 2px;
      }

      .tab-label-mobile {
        font-size: 8px;
      }
    }
  }
}

@media (min-width: 1200px) {
  .tab-nav {
    gap: 10px;
    padding: 12px 28px;

    .tab-item {
      padding: 6px 18px;
      min-width: 80px;

      .tab-icon {
        font-size: 20px;
        margin-bottom: 4px;
      }

      .tab-label {
        font-size: 11px;
      }
    }
  }
}

/* Element UI 卡片模式样式覆盖 */
@media (min-width: 769px) {
  ::v-deep .el-carousel {
    overflow: visible;

    .el-carousel__container {
      overflow: visible;
    }

    &.el-carousel--card {
      .el-carousel__item {
        border-radius: 16px;
        overflow: hidden;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

        &.is-active {
          transform: scale(1);
          z-index: 2;
        }

        &:not(.is-active) {
          transform: scale(0.85);
          opacity: 0.7;
        }
      }
    }
  }
}

/* 移动端显示指示器 */
::v-deep .el-carousel__indicators {
  @media (max-width: 768px) {
    display: flex !important;
    bottom: 10px;

    .el-carousel__indicator button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.5);
    }

    .is-active button {
      background-color: white;
      width: 10px;
      height: 10px;
    }
  }
}

@media (min-width: 769px) {
  ::v-deep .el-carousel__indicators {
    display: none !important;
  }
}

/* Carousel 箭头样式 - 移除悬浮动画 */
::v-deep .el-carousel__arrow {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  opacity: 0.5;
  transition: none;
  z-index: 15;

  &:hover {
    opacity: 1;
  }

  i {
    font-size: 18px;
    font-weight: bold;
  }
}

@media (max-width: 768px) {
  ::v-deep .el-carousel__arrow {
    width: 30px;
    height: 30px;

    i {
      font-size: 12px;
    }
  }
}
</style>